import { render, staticRenderFns } from "./PayHotForm.vue?vue&type=template&id=5ba40ef6"
import script from "./PayHotForm.vue?vue&type=script&lang=js"
export * from "./PayHotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports